import { useHistory } from 'react-router-dom'
import { AxiosError } from 'axios'

import { AppRoute } from 'routing/AppRoute.enum'
import { Queries } from 'api/queries.enum'
import {
    GetPulseSurveyDetailParams,
    GetPulseSurveyDetailResponse,
} from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { getPulseSurveyDetail } from 'api/actions/pulseSurveys/pulseSurveysActions'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { preventRefetchQueryOptions } from 'utils/queryOptions'
import { useQuery } from 'hooks/useQuery'

export const useGetPulseSurveyDetail = (params: GetPulseSurveyDetailParams, options?: { enabled?: boolean }) => {
    const history = useHistory()

    return useQuery<GetPulseSurveyDetailResponse, AxiosError>({
        queryKey: [Queries.getPulseSurveyDetail, params],
        queryFn: () => getPulseSurveyDetail(params),
        onError: () => {
            history.push(generateCompanyURI(AppRoute.PulseSurvey))
        },
        enabled: options?.enabled,
        ...preventRefetchQueryOptions,
    })
}
